import React from 'react'

import { ButtonClean, Fieldset, InputUI, useModalContext } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'
import type { useUsersQuery } from '@queries/useUsersQuery'

import { SelectTeamStaff } from '../../../SelectTeamStaff/SelectTeamStaff'
import { FormFields, type FormValues } from '../../hooks/useBadgeForm/types'
import { SelectedMember } from '../SelectedMember'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
  usersQuery: ReturnType<typeof useUsersQuery>['usersQuery']
}

export const SelectedTeamMembers = ({ form, usersQuery }: Props) => {
  const modal = useModalContext()

  const renderMembersList = () => {
    if (form.values.badgeType === 'Verified' && form.values.verifiedApplyToType !== 'Selected')
      return null
    if (form.values.badgeType !== 'Verified' && !form.values.giveToSelectedTeamStaff) return null
    if (!form.values.manuallyAssignedTeamStaff.length) return null

    return (
      <Fieldset.Row inner>
        <div style={{ width: '100%' }}>
          {form.values.manuallyAssignedTeamStaff.map((email) => {
            const user = usersQuery?.data?.users.find((user) => user.email === email)

            return (
              <SelectedMember
                key={email}
                nickname={user?.fullName || user?.email || email}
                onRemove={() => {
                  form.setFieldValue(
                    FormFields.manuallyAssignedTeamStaff,
                    form.values.manuallyAssignedTeamStaff.filter(
                      (teamStaff) => teamStaff !== email,
                    ),
                  )
                }}
              />
            )
          })}
        </div>
      </Fieldset.Row>
    )
  }

  const renderAddMembersButton = () => {
    if (form.values.badgeType === 'Verified' && form.values.verifiedApplyToType !== 'Selected')
      return null
    if (form.values.badgeType !== 'Verified' && !form.values.giveToSelectedTeamStaff) return null

    return (
      <Fieldset.Row inner>
        <ButtonClean
          label="Add or remove internal team staff"
          onClick={() =>
            modal.open(SelectTeamStaff, {
              selectedTeamStaff: form.values.manuallyAssignedTeamStaff,
              onSave: (selectedTeamStaff) => {
                form.setFieldValue(FormFields.manuallyAssignedTeamStaff, selectedTeamStaff)
              },
            })
          }
        />
      </Fieldset.Row>
    )
  }

  return (
    <>
      {renderMembersList()}
      {renderAddMembersButton()}
      {form.errors.manuallyAssignedTeamStaff &&
        typeof form.errors.manuallyAssignedTeamStaff === 'string' && (
          <Fieldset.Row inner>
            <InputUI.Error $withoutMargin>{form.errors.manuallyAssignedTeamStaff}</InputUI.Error>
          </Fieldset.Row>
        )}
    </>
  )
}
